import { c as _c } from "react/compiler-runtime";
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { TreeView } from '@lexical/react/LexicalTreeView';
export default function TreeViewPlugin() {
  const $ = _c(2);
  const [editor] = useLexicalComposerContext();
  let t0;
  if ($[0] !== editor) {
    t0 = <TreeView viewClassName="tree-view-output" timeTravelPanelClassName="debug-timetravel-panel" timeTravelButtonClassName="debug-timetravel-button" timeTravelPanelSliderClassName="debug-timetravel-panel-slider" timeTravelPanelButtonClassName="debug-timetravel-panel-button" treeTypeButtonClassName="debug-timetravel-tree-type-button" editor={editor} />;
    $[0] = editor;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}